// import { AccountDetails, GET_VEHICLES_DATA, SearchAccounts } from "../../../../Utils/AllPagesQuriesAndMutations";

// export const TuckFigma = [
//   {
//     id: Math.random() * 10,
//     name: "Section1",
//     fields: [
//       {
//         id: Math.random() * 10,
//         name: "Account_ID",
//         label: "Account",
//         type: "InputDropForQuery",
//         dropdowncontent: SearchAccounts,
//         isRequired: true,
//       },
//       {
//         id: Math.random() * 10,
//         name: "Vehicle_No",
//         label: "Vehicle No",
//         type: "InputDropForQuery",
//         EMTQuery: {
//           headers: { "X-GraphQL-Server": "secondary" },
//         },
//         Reference_field: "Account_ID",
//         dropdowncontent: GET_VEHICLES_DATA,
//         isRequired: true,
//       },
//     ],
//   },
//   {
//     id: Math.random() * 10,
//     name: "ButtonSection",
//   },
//   {
//     id: Math.random() * 10,
//     name: "Section2",
//     fields: [
//       {
//         id: Math.random() * 10,
//         name: "Loading_Search_Radius",
//         label: "From Radius",
//         type: "inputdrop",
//         dropdowncontent: [50, 100, 150, 200, 250, 300],
//         isRequired: true,
//         notSearchable: true,
//       },
//       {
//         id: Math.random() * 10,
//         name: "Unloading_Search_Radius",
//         label: "To Radius",
//         type: "inputdrop",
//         dropdowncontent: [50, 100, 150, 200, 250, 300],
//         isRequired: true,
//         notSearchable: true,
//       },
//     ],
//   },
//   {
//     id: Math.random() * 10,
//     name: "Section3",
//     fields: [
//       {
//         id: Math.random() * 10,
//         name: "Post_Duration",
//         label: "Post For",
//         type: "inputdrop",
//         dropdowncontent: [1, 2, 4, 6, 12, 24],
//         isRequired: true,
//         notSearchable: true,
//       },
//       {
//         id: Math.random() * 10,
//         name: "Contact_No",
//         label: "Contact",
//         type: "number",
//         Reference_Value_field: "Account_ID.Number",
//         min: 10,
//         max: 10,

//       },
//       {
//         id: Math.random() * 10,
//         name: "Rate_Per_Km",
//         label: "Rate per Km",
//         type: "number",
//       },
//     ],
//   },
//   {
//     id: Math.random() * 10,
//     name: "Section4",
//     fields: [
//       {
//         id: Math.random() * 10,
//         name: "Notes",
//         label: "Notes",
//         type: "textarea",
//       },
//     ],
//   },
// ];

export const TuckFigma = [
  {
    id: Math.random() * 10,
    name: "Section1",
    fields: [
      {
        id: Math.random() * 10,
        name: "Vehicle_No",
        label: "Vehicle No ",
        type: "InputDropForQuery",
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
        Reference_field: "Account_ID",
        masterName: "My_Vehicles",
        isRequired: true,
        notSearchable: true,
      },
      {
        id: Math.random() * 10,
        name: "Loading_Search_Radius",
        label: "From Radius",
        type: "inputdrop",
        dropdowncontent: [50, 75, 100, 150, 200, 300],
        isRequired: true,
        notSearchable: true,
      },
      {
        id: Math.random() * 10,
        name: "Unloading_Search_Radius",
        label: "To Radius",
        type: "inputdrop",
        dropdowncontent: [50, 75, 100, 150, 200, 300],

        isRequired: true,
        notSearchable: true,
      },
      {
        id: Math.random() * 10,
        name: "Post_Duration",
        label: "Post For",
        type: "inputdrop",
        dropdowncontent: [2, 6, 12, 24, 48],

        isRequired: true,
        notSearchable: true,
      },
      {
        id: Math.random() * 10,
        name: "Contact_No",
        label: "Contact",
        type: "number",
        Reference_Value_field: "Account_ID.Mobile_Number",
        min: 10,
        max: 10,
        isRequired: true,
        ValidationType: "VALID_NUMBER",
      },
      {
        id: Math.random() * 10,
        name: "Rate_Per_Km",
        label: "Rate per Km",
        type: "number",
      },
      {
        id: Math.random() * 10,
        name: "Notes",
        label: "Notes",
        type: "textarea",
      },
    ],
  },
];
